export default {
  ratings: [
    { value: 'rating_7', logo: require('@/assets/ratings/rating_7.svg'), label: '+7' },
    { value: 'rating_12', logo: require('@/assets/ratings/rating_12.svg'), label: '+12' },
    { value: 'rating_16', logo: require('@/assets/ratings/rating_16.svg'), label: '+16' },
    { value: 'rating_18', logo: require('@/assets/ratings/rating_18.svg'), label: '+18' },
    { value: 'rating_tp', logo: require('@/assets/ratings/rating_tp.svg'), label: 'TP' },
    { value: 'rating_x', logo: require('@/assets/ratings/rating_x.svg'), label: 'X' }
  ],
  bannerActions: [
    { value: 'program', label: 'Abrir programa' },
    { value: 'url', label: 'Abrir enlace' },
    { value: 'image', label: 'Imagen solamente' }
  ],
  videoStatus: [
    { value: 'pending', label: 'Pending', color: '#50A0FD' },
    { value: 'transcoding', label: 'Transcoding', color: '#F5A623' },
    { value: 'error', label: 'Error', color: '#F55468' },
    { value: 'ready', label: 'Ready', color: '#89C53E' }
  ],
  aspectRatios: {
    banner: { w: 1000, h: 560 },
    banner_2: { w: 1740, h: 617 },
    program: { w: 400, h: 620 },
    program_h: { w: 363, h: 205 },
    video: { w: 160 * 2, h: 90 * 2 },
    tag_icon: { w: 372, h: 200 },
    tag_bg: { w: 768, h: 635 }
  }
}
